import React from "react";
import PropTypes from "prop-types";
import "./Ribbon.scss";

const Ribbon = ({ children }) => {
    // -------------------------------------------------------------------------
    // MARK:   If the Ribbon heading is longer than 30 characters than we need to
    //         to set special styling to handle the extra space needed to display legibly.
    //         The helper function takes in the children passed and determines the length
    //         of the string. We then attach a different class to handle the sizing
    //         on various screens in Ribbon.scss. If under 30 characters,
    //         default styling will apply
    // -------------------------------------------------------------------------
    const calculateWidthByChar = (string) => {
        let widthClassByChar = "";
        if (
            string &&
            typeof string === "string" &&
            string.length >= 30 &&
            string.length < 75
        ) {
            widthClassByChar = "ribbon--three-quarter";
        } else if (string && string.length >= 75) {
            widthClassByChar = "ribbon--full";
        }
        return widthClassByChar;
    };
    return (
        <div
            className={`ribbon ${calculateWidthByChar(children)}`}
            data-testid="ribbon"
        >
            <div className="ribbon__h3">{children}</div>
        </div>
    );
};

Ribbon.propTypes = {
    children: PropTypes.string.isRequired,
};

export default Ribbon;
